import script from "./employee-salary-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-salary-modal.vue?vue&type=script&setup=true&lang=js"

import "./employee-salary-modal.vue?vue&type=style&index=0&id=f590ccde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f590ccde"]])

export default __exports__